$(document).ready(function() {
  var CHANGE_INTERESTED_TYPE = 'change-interested-type';
  var DIV_CUSTOMER_FIELDS = 'customer_fields';
  var DIV_PROSPECT_FIELDS = 'prospect_fields';

  function toggleInterestedType(type) {
    hideElement(DIV_CUSTOMER_FIELDS, true);
    hideElement(DIV_PROSPECT_FIELDS, true);
    $('#' + DIV_CUSTOMER_FIELDS + ' input, #' + DIV_CUSTOMER_FIELDS + ' select, #' + DIV_CUSTOMER_FIELDS + ' textarea').prop('disabled', true);
    $('#' + DIV_PROSPECT_FIELDS + ' input, #' + DIV_PROSPECT_FIELDS + ' select, #' + DIV_PROSPECT_FIELDS + ' textarea').prop('disabled', true);

    if(type == 'Customer'){
      hideElement(DIV_CUSTOMER_FIELDS, false);
      $('#' + DIV_CUSTOMER_FIELDS + ' input, #' + DIV_CUSTOMER_FIELDS + ' select, #' + DIV_CUSTOMER_FIELDS + ' textarea').prop('disabled', false);
    } else if(type == 'Prospect'){
      hideElement(DIV_PROSPECT_FIELDS, false);
      $('#' + DIV_PROSPECT_FIELDS + ' input, #' + DIV_PROSPECT_FIELDS + ' select, #' + DIV_PROSPECT_FIELDS + ' textarea').prop('disabled', false);
    }
  }

  $(document).on('click', '.' + CHANGE_INTERESTED_TYPE, function(){
    toggleInterestedType(this.value);
  });

  // garante estado correto no load inicial (new e edit)
  var checked = $('.' + CHANGE_INTERESTED_TYPE + ':checked').val();
  if (checked) {
    toggleInterestedType(checked);
  }
});